/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { isPresent } from '@yp/common/identity.ts';

export async function setOrientationLock(orientation: 'portrait' | 'landscape' | undefined) {
  let result = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const s = screen as any;
  if (s.orientation.lock) {
    try {
      await s.orientation.lock(orientation ?? 'any');
      result = true;
    } catch {
      // This space intentionally left blank.
    }
  } else if (isPresent(orientation)) {
    const lockOrientationUniversal =
      s.lockOrientation || s.mozLockOrientation || s.msLockOrientation;
    if (lockOrientationUniversal?.(orientation)) {
      result = true;
    }
  } else {
    const unlockOrientation =
      s.unlockOrientation ||
      s.mozUnlockOrientation ||
      s.msUnlockOrientation ||
      (s.orientation && s.orientation.unlock);
    if (unlockOrientation?.()) {
      result = true;
    }
  }
  if (result) {
    console.log('Orientation lock:', orientation);
  } else {
    console.log('Orientation lock failed.');
  }
  return result;
}
